import axios from 'axios'
import { setLocalStorage, getLocalStorage, removeLocalStorage } from "../utils/localStorage"
import  {myConfig} from "@/static/utils/dtpconfig"
let service = axios.create({
  // baseURL: 'https://pro.gispai.com/',
  // baseURL: "http://124.71.184.55:11228/",
  // baseURL: "http://124.70.192.145:11228/",
  baseURL: myConfig.testUrl,
  timeout: 30000
})
service.defaults.headers.common['Content-Type'] = 'application/json'

// request拦截器
service.interceptors.request.use(config => {
  // console.log("lanj")
  config.headers.token = getLocalStorage("user-token-gispai")
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
// service.interceptors.response.use(
//   response => {
//     if (response.status !== 200) {
//       if (response.status === 403){
//           Message.error('登录过期，请从新登录')
//           localStorage.clear()
//           // localStorage.removeItem('user-token')
//           store.commit('setTag', []);
//           router.replace({
//               path: '/'
//           })
          
//       }
//       return Promise.reject(response)
//   } else {
//     if(response.data.state!==1){
//       Message.error(response.data.msg)
//     }
//     return response
//   }
//   }, error => {
//     console.log(error)
//   }
// )


service.interceptors.response.use(
  response => {
      if (response.status !== 200) {
          if (response.status === 403){
              Message.error('登录过期，请从新登录')
              localStorage.clear()
              // localStorage.removeItem('user-token')
              store.commit('setTag', []);
              router.replace({
                  path: '/'
              })
          }
          return Promise.reject(response)
      } else {
        return response
      }
  },error => {
      return Promise.reject(error)
  }
);

export default service
